import React, { useEffect, useState } from "react";
import anime from "animejs";
import { NavLink } from "react-router-dom";
import { routes } from "../App";
import resume from "../img/Pratyush_Kumar_Rai_Resume.pdf";
import "./styles/navbar.scss";

function Navbar({ onOpenPalette }) {
  const [click, setClick] = useState(false);

  const handleClick = () => setClick(!click);
  const closeMenu = () => setClick(false);

  useEffect(() => {
    const tl = anime.timeline({ easing: "easeInOutSine", loop: false });

    tl.add({
      targets: "#navbar",
      translateY: [-100, 15],
      duration: 800,
      easing: "easeOutExpo",
    });

    if (
      (window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth) > 768
    ) {
      tl.add(
        {
          targets: "#navbar a, .nav-cmd-btn",
          opacity: [0, 1],
          delay: anime.stagger(150),
        },
        "-=300"
      );
    } else {
      tl.add(
        {
          targets: [".menu-icon", ".navbar-logo", ".nav-cmd-btn"],
          opacity: [0, 1],
          delay: anime.stagger(150),
        },
        "-=300"
      );
    }
  }, []);

  return (
    <nav id="navbar" aria-label="Main Navigation">
      <div className="navbar-container">
        <div className="menu-icon" onClick={handleClick} aria-label="Toggle menu" role="button" tabIndex={0}>
          <div className={click ? "menu-close" : "menu-burger"}></div>
        </div>

        <ul className={click ? "menu active" : "menu"}>
          {routes.slice(1).map((route) => (
            <li key={route.path}>
              <NavLink
                key={route.path}
                to={route.path}
                className="nav-link"
                activeClassName="active"
                onClick={closeMenu}
              >
                {route.name}
              </NavLink>
            </li>
          ))}
          <li>
            <a
              href={resume}
              className="nav-link resume"
              download="Pratyush_Kumar_Rai_Resume.pdf"
              aria-label="Download Pratyush Kumar Rai's Resume"
            >
              <i className="fa fa-download resume-nav-icon" aria-hidden="true"></i>
              <span>Resume</span>
            </a>
          </li>
        </ul>

        <div className="navbar-right">
          <button
            type="button"
            className="nav-cmd-btn font-mono"
            onClick={onOpenPalette}
            title="Open Command Palette (Ctrl+K or Cmd+K)"
            aria-label="Open Command Palette"
          >
            <i className="fa fa-terminal" aria-hidden="true"></i>
            <span className="cmd-text">⌘K</span>
          </button>

          <NavLink exact to="/" className="navbar-logo" onClick={closeMenu} aria-label="Home page">
            P
          </NavLink>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
